import { createAction, props } from '@ngrx/store';
export const setModelPortfolioToPushToIRebal = createAction('[IRebal Push Model] Set Model Portfolio to Push to iRebal', props());
export const removeModelPortfolioToPushToIRebal = createAction('[IRebal Push Model] Remove Model Portfolio to Push to iRebal');
